import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';
export default class LogUtil
{

    static CLIENTLOG = "clientLog";
    static ERRORINFO = "errorInfo";
    static OPR = "operate";
    static OVERTIME_FRAME = "overTimeFrame";
    static RPCCALL = "rpcCall";

    static clientLogs = {remoteClass:"java.util.Map",errorInfo:[],operate:[],overTimeFrame:[],rpcCall:[]};
    static setUserOprLog(options)
    {
        return;
        let userInfos = window.userInfos?window.userInfos:window.parent.window.userInfos;
        let defaultOption = {
            remoteClass:"java.util.Map",
            dateTime:new Date().getTime(),
            dataArea:userInfos.subSysId,
            userId:userInfos.userId,
            userName:userInfos.userName,
            clientSessionId:userInfos.userSessionId,
            formId:"",formDataSourceName:"",formItemName:"",remark:""
        }; 
        /*IndexedDBUtil.addData(IndexedDBUtil.DB.db,IndexedDBUtil.DB.name3,
            Object.assign(defaultOption,options)
        );*/
        LogUtil.clientLogs.operate.push(Object.assign(defaultOption,options));
    }

    static setRpcLog(options)
    {
        LogUtil.clientLogs.rpcCall.push(options);
    }

    static setOperate(options)
    {
        LogUtil.clientLogs.operate.push(options);
    }

    static setGlobalError(options)
    {
        let userInfos = window.userInfos?window.userInfos:window.parent.window.userInfos;
        let defaultOption = {
            remoteClass:"java.util.Map",
            dateTime:new Date().getTime()+"",
            dataArea:userInfos.subSysId,
            userId:userInfos.userId,
            userName:userInfos.userName,
            clientSessionId:userInfos.userSessionId,
            remark:"",stackInfo:""
        };
        LogUtil.clientLogs.errorInfo.push(Object.assign(defaultOption,options));
    }

    static upLog(datas)
    {
        var command = Command.createService("gongqi.erp.framework.services.ClientLoggingService","saveLog","void");
        command.appendArg(LogUtil.clientLogs,"Object");
        var remoteArg = {
            command:command,
            resultFunction:LogUtil.rpcUpLoadLog,
            faultFunction:LogUtil.rpcFaultUpLoadLog,
            autoLock:false,
            autoUnlock:false
        };
        ServiceHelper.addTokenWithCommand(remoteArg);
    }

    static upNetWorkErrorLog(datas)
    {
        if(datas && datas.length)
        {
            let data = {remoteClass:"java.util.Map",rpcCallError:datas};
            var command = Command.createService("gongqi.erp.framework.services.ClientLoggingService","saveLog","void");
            command.appendArg(data,"Object");
            var remoteArg = {
                command:command,
                resultFunction:LogUtil.rpcUpLoadErrorLog,
                autoLock:false,
                autoUnlock:false
            };
            ServiceHelper.addTokenWithCommand(remoteArg);
        }
    }

    static rpcUpLoadErrorLog(data)
    {

    }

    static rpcUpLoadLog(data)
    {
        LogUtil.clientLogs = {remoteClass:"java.util.Map",errorInfo:[],operate:[],overTimeFrame:[],rpcCall:[]};
    }

    static rpcFaultUpLoadLog(data)
    {
        //日志上传错误 不弹出任何提示 避免当服务器关掉时 每隔一分钟就弹出断网提示
    }

    
}


// WEBPACK FOOTER //
// ./src/utils/LogUtil.js